import styles from './breadcrumbs.module.sass';
import { LinkProps, LinkWrapper } from '../LinkWrapper';
import { FontIcon } from '../FontIcon';
import React from 'react';

interface BreadcrumbsProps extends React.HTMLAttributes<HTMLDivElement> {
    items: LinkProps[];
}

export const Breadcrumbs = ({ items, ...props }: BreadcrumbsProps) => {
    return (
        <div className={styles.breadcrumbs} {...props}>
            {items.map((item, index) => (
                <React.Fragment key={`breadcrumb-${index}`}>
                    {item.href ? <LinkWrapper link={item} className={styles.link} /> : <span>{item.text}</span>}
                    {index < items.length - 1 && (
                        <FontIcon className={styles.separator} name="chevron-left" rotate="flip" size="smaller" md="smaller" />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};
